// Resource Type Options
export const RESOURCE_TYPE_OPTIONS = [
  { value: 'doctor', label: 'Doctor 医生' },
  { value: 'cma', label: 'CMA' },
  { value: 'pharmacy', label: 'Pharmacy 药房' },
  { value: 'hospital', label: 'Hospital 医院' },
  { value: 'surgical center', label: 'Surgical Center 外科手术中心' },
  { value: 'government agency', label: 'Government Agency 政府机构' },
  { value: 'other', label: 'Other 其他' },
];

export const RESOURCE_TYPE_TEXT = {
  'doctor': 'Doctor 医生',
  'cma': 'CMA',
  'pharmacy': 'Pharmacy 药房',
  'hospital': 'Hospital 医院',
  'surgical center': 'Surgical Center 外科手术中心',
  'government agency': 'Government Agency 政府机构',
  'other': 'Other 其他',
};

// Resource Specialty Options
export const RESOURCE_SPECIALTY_OPTIONS = [
  { value: 'Family Medicine (PCP)', label: 'Primary Care Provider (PCP) 家庭医生' },
  { value: 'Acupuncture', label: 'Acupuncture 针灸' },
  { value: 'Allergy & Asthma', label: 'Allergy & Asthma 过敏与哮喘' },
  { value: 'Audiology', label: 'Audiology 听力学' },
  { value: 'Behavior Health/Social Worker', label: 'Behavioral Health / Social Worker 行为健康 / 社工' },
  { value: 'Bloodwork', label: 'Bloodwork 验血' },
  { value: 'Botox Therapy', label: 'Botox Therapy 肉毒杆菌治疗' },
  { value: 'Breast Surgery', label: 'Breast Surgery 乳房外科' },
  { value: 'Cardiology', label: 'Cardiology 心脏病科' },
  { value: 'Cardiovascular', label: 'Cardiovascular 心血管科' },
  { value: 'Colon & Rectal Surgery', label: 'Colon & Rectal Surgery 结肠与直肠外科' },
  { value: 'Dentist', label: 'Dental 牙科' },
  { value: 'Dermatology', label: 'Dermatology 皮肤科' },
  { value: 'Dialysis', label: 'Dialysis 透析' },
  { value: 'Endocrinology & Diabetes', label: 'Endocrinology & Diabetes 内分泌与糖尿病科' },
  { value: 'Endodontist', label: 'Endodontics 牙髓科' },
  { value: 'Endoscopy Center', label: 'Endoscopy Center 内窥镜中心' },
  { value: 'Otolaryngology (ENT)', label: 'Otolaryngology (ENT) 耳鼻喉科' },
  { value: 'Eye Surgery Center', label: 'Eye Surgery Center 眼科手术中心' },
  { value: 'Gastroenterology', label: 'Gastroenterology 胃肠科' },
  { value: 'General Surgery', label: 'General Surgery 普通外科' },
  { value: 'GYN Oncology', label: 'GYN Oncology 妇科肿瘤科' },
  { value: 'Head & Neck Surgery', label: 'Head & Neck Surgery 头颈外科' },
  { value: 'Health Boutique', label: 'Health Boutique 医疗服饰' },
  { value: 'Hearing Aids', label: 'Hearing Aids 助听器' },
  { value: 'Hematology & Oncology', label: 'Hematology & Oncology 血液与肿瘤科' },
  { value: 'Hepatology', label: 'Hepatology 肝病科' },
  { value: 'Hospital', label: 'Hospital 医院' },
  { value: 'Infectious disease', label: 'Infectious Disease 传染病科' },
  { value: 'Internal Medicine', label: 'Internal Medicine 内科' },
  { value: 'Medical Center', label: 'Medical Center 医疗中心' },
  { value: 'Lab', label: 'Lab 化验室' },
  { value: 'Modified Barium Swallow (MBS) Study', label: 'Modified Barium Swallow (MBS) Study 吞咽检查' },
  { value: 'Medical Supply', label: 'Medical Supply 医疗用品' },
  { value: 'Nephrology', label: 'Nephrology 肾脏科' },
  { value: 'Neuro Surgeon', label: 'Neurosurgery 神经外科' },
  { value: 'Neurology', label: 'Neurology 神经科' },
  { value: 'OB/GYN', label: 'OB/GYN 妇科' },
  { value: 'Optometry (OD)', label: 'Optometry (OD) 视光科' },
  { value: 'Oncology', label: 'Oncology 肿瘤科' },
  { value: 'Oncology Center', label: 'Oncology Center 肿瘤中心' },
  { value: 'Ophthalmology', label: 'Ophthalmology 眼科' },
  { value: 'Ophthalmology (Retina Specialist)', label: 'Ophthalmology (Retina Specialist) 眼科（视网膜专科）' },
  { value: 'Oral Surgery', label: 'Oral Surgery 口腔外科' },
  { value: 'Orthopaedic', label: 'Orthopaedic 骨科' },
  { value: 'Osteopath', label: 'Osteopathy 整骨医学' },
  { value: 'Pain Management', label: 'Pain Management 疼痛管理' },
  { value: 'Periodontist', label: 'Periodontics 牙周科' },
  { value: 'Pharmacy', label: 'Pharmacy 药房' },
  { value: 'Physical Therapy', label: 'Physical Therapy 物理治疗' },
  { value: 'Physical, Occupational, & Speech Therapy', label: 'Physical, Occupational, & Speech Therapy 物理、职业与语言治疗' },
  { value: 'Podiatry', label: 'Podiatry 足科' },
  { value: 'Psychiatry', label: 'Psychiatry 精神科' },
  { value: 'Pulmonology', label: 'Pulmonology 呼吸科' },
  { value: 'Radiation Oncology', label: 'Radiation Oncology 放射肿瘤科' },
  { value: 'Radiology', label: 'Radiology 放射科' },
  { value: 'Rehabilitation', label: 'Rehabilitation 康复科' },
  { value: 'Rheumatology', label: 'Rheumatology 风湿病科' },
  { value: 'Sleep Medicine', label: 'Sleep Medicine 睡眠医学' },
  { value: 'Sleep Study', label: 'Sleep Study 睡眠测试' },
  { value: 'Substance Abuse Treatment', label: 'Substance Abuse Treatment 成瘾治疗' },
  { value: 'Sports Medicine', label: 'Sports Medicine 运动医学' },
  { value: 'Surgery', label: 'Surgery 外科' },
  { value: 'Surgery Center', label: 'Surgery Center 外科手术中心' },
  { value: 'Thoracic Surgery', label: 'Thoracic Surgery 胸外科' },
  { value: 'Traditional Chinese Medicine', label: 'Traditional Chinese Medicine 中医' },
  { value: 'Urgent Care', label: 'Urgent Care 急诊' },
  { value: 'Urogynecology', label: 'Urogynecology 泌尿妇科' },
  { value: 'Urology', label: 'Urology 泌尿科' },
  { value: 'Vascular and Vein', label: 'Vascular & Vein 血管科' },
  { value: 'Vascular & Interventional Radiologist', label: 'Vascular & Interventional Radiology 血管与介入放射科' },
  { value: 'Weight Loss / GYM', label: 'Weight Loss / GYM 减重 / 健身房' },
  { value: 'Wound Clinic', label: 'Wound Clinic 伤口诊所' },
  { value: 'other', label: 'Other - please specify' },
];

export const RESOURCE_SPECIALTY_TEXT = Object.fromEntries(
  RESOURCE_SPECIALTY_OPTIONS.map((opt) => [opt.value, opt.label])
);

// Legacy list format for backward compatibility
export const RESOURCE_SPECIALTY_LIST = RESOURCE_SPECIALTY_OPTIONS.map(opt => opt.value);

export const formatSpecialtyLabel = (specialty, specialtyOther = "") => {
  const s = `${specialty || ""}`.trim();
  if (!s) return "";
  if (s === "other" && `${specialtyOther || ""}`.trim()) {
    return `Other - please specify (${`${specialtyOther}`.trim()})`;
  }
  if (s === "other") return "Other - please specify";
  return RESOURCE_SPECIALTY_TEXT[s] || s;
};

/** When specialty is `other`, show free-text from `specialty_other`. */
export const formatResourceSpecialtyDisplay = (resource) => {
  if (!resource) return "";
  return formatSpecialtyLabel(resource.specialty, resource.specialty_other);
};

/** Live provider specialty, then snapshot stored on the medical event. */
export const resolveEventProviderSpecialtyDisplay = (resource, eventData = {}) => {
  const fromResource = formatResourceSpecialtyDisplay(resource);
  if (fromResource) return fromResource;
  return formatSpecialtyLabel(
    eventData?.resource_specialty || eventData?.specialty,
    eventData?.resource_specialty_other || eventData?.specialty_other
  );
};

/**
 * Non-empty provider phone values (primary + phone 2–5).
 */
export const getProviderPhoneValues = (resource, eventData = {}) => (
  [
    `${resource?.phone ?? eventData?.resource_phone ?? ""}`.trim(),
    `${resource?.contact ?? eventData?.resource_contact ?? ""}`.trim(),
    `${resource?.phone3 ?? eventData?.resource_phone3 ?? ""}`.trim(),
    `${resource?.phone4 ?? eventData?.resource_phone4 ?? ""}`.trim(),
    `${resource?.phone5 ?? eventData?.resource_phone5 ?? ""}`.trim(),
  ].filter(Boolean)
);

/** Digits only — used so search ignores phone formatting. */
export const digitsOnlyPhoneValue = (value) => String(value || "").replace(/\D/g, "");

/**
 * True when keyword digits appear in any provider phone or fax (format-agnostic).
 * e.g. `4102079816` matches `(410) 207-9816`.
 */
export const resourceMatchesPhoneOrFaxKeyword = (resource, keyword) => {
  const queryDigits = digitsOnlyPhoneValue(keyword);
  if (!queryDigits) return false;
  const fields = [
    ...getProviderPhoneValues(resource),
    `${resource?.fax || ""}`.trim(),
  ].filter(Boolean);
  return fields.some((value) => digitsOnlyPhoneValue(value).includes(queryDigits));
};

/**
 * How many phone inputs to show (1–5) based on stored values.
 * Primary is always shown; extras appear when they have data.
 */
export const getProviderPhoneFieldCount = (resource) => {
  if (!resource) return 1;
  if (`${resource.phone5 || ""}`.trim()) return 5;
  if (`${resource.phone4 || ""}`.trim()) return 4;
  if (`${resource.phone3 || ""}`.trim()) return 3;
  if (`${resource.contact || ""}`.trim()) return 2;
  return 1;
};

/**
 * Provider phones for list columns: `1. …\n2. …` (omit empty).
 */
export const formatProviderPhonesListDisplay = (resource, eventData = {}) => {
  const phones = getProviderPhoneValues(resource, eventData);
  if (!phones.length) return "";
  return phones.map((value, index) => `${index + 1}. ${value}`).join("\n");
};

/**
 * Provider Contact for medical lists: `P1 : … ; P2 : … ; … ; F : …`
 * (primary + phone 2–5 + fax — omit empty parts).
 */
export const formatProviderContactDisplay = (resource, eventData = {}) => {
  const phones = getProviderPhoneValues(resource, eventData);
  const fax = `${resource?.fax ?? eventData?.resource_fax ?? ""}`.trim();
  const parts = phones.map((value, index) => `P${index + 1} : ${value}`);
  if (fax) parts.push(`F : ${fax}`);
  return parts.join(" ; ");
};

/**
 * Provider address for medical lists / notifications.
 * Same priority as Multi Days List + visit records: live provider, then event snapshot.
 */
export const formatMedicalProviderAddressDisplay = (resource, eventData = {}) => {
  const normalize = (value) =>
    `${value ?? ""}`
      .replace(/\r\n/g, "\n")
      .replace(/\n+/g, " ")
      .replace(/\s+/g, " ")
      .trim();

  if (resource) {
    const legacy = normalize(resource.address);
    if (legacy) return legacy;
    const structured = [
      resource.address_line_1,
      resource.address_line_2,
      resource.city,
      resource.state,
      resource.zipcode,
    ]
      .map((part) => `${part ?? ""}`.trim())
      .filter(Boolean)
      .join(", ");
    if (structured) return structured;
  }
  return normalize(eventData?.resource_address);
};
